import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select, Spin } from 'antd';

import { handleUpdatePostApi } from '@/api/crud';
import { subscribeApiEndpoints } from '@/api/endpoints';
import { Heading } from '@/components';
import DateField from '@/utils/date/Date';
import GlobalDivider from '@/utils/divider/GlobalDivider';

const EditSubscriptionForm = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();

  const abortController = new AbortController();

  useEffect(() => {
    (async function () {
      try {
        const signal = abortController.signal;
        const res = await subscribeApiEndpoints.retrieve(id, signal);

        if (res.data.data) {
          const subscription = res.data.data;
          form.setFieldsValue({
            userId: subscription.userId,
            version: subscription.version,
            noOfCompany: subscription.noOfCompany,
            noOfBranch: subscription.noOfBranch,
            noOfUser: subscription.noOfUser,
            startDate: subscription.startDate,
            expiryDate: subscription.expiryDate,
            mobileNumber: subscription.mobileNumber,
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    })();

    return () => {
      abortController.abort();
    };
  }, [id]);

  const versionOption = [
    {
      value: '1',
      label: '1',
    },
    {
      value: '2',
      label: '2',
    },
    {
      value: '3',
      label: '3',
    },
  ];

  const navigateToList = () => {
    navigate('/subscription/list/');
  };
  return (
    <>
      <Spin spinning={loading}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            className="username"
            labelCol={{
              span: 12,
            }}
            wrapperCol={{
              span: 24,
            }}
            onFinish={(value) => {
              handleUpdatePostApi(
                id,
                subscribeApiEndpoints.update,
                {
                  ...value,
                  startDate: value.startDate,
                  expiryDate: value.expiryDate,
                },
                setLoading,
                form,
                () => {},
                navigateToList,
              );
            }}
          >
            <GlobalDivider name="Edit Subscription" />
            <Row gutter={[16, 16]}>
              {/* <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item name="userId" label="Customer Name">
                  <Select
                    showSearch
                    loading={isLoading}
                    filterOption={(value, option) =>
                      optionSearchFunction(value, option)
                    }
                    options={
                      isSuccess
                        ? customers.map((option) => {
                            return {
                              value: option.referenceId,
                              label: option.name,
                            }
                          })
                        : []
                    }
                  />
                </Form.Item>
              </Col> */}

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="version" label="Version">
                  <Select
                    placeholder="Select Version"
                    options={versionOption}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="noOfCompany" label="No of Company">
                  <Input placeholder="No of Company" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="noOfBranch" label="No of Branch">
                  <Input placeholder="Number of Branch" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="noOfUser" label="No of users">
                  <Input placeholder="No of users" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="startDate" label="Start Date">
                  <DateField />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="expiryDate" label="Expiry Date">
                  <DateField />
                </Form.Item>
              </Col>

              {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item name="mobileNumber" label="Mobile">
                  <Input
                    type="text"
                    // value={date}
                    // onKeyDown={handleKeyDown}
                    placeholder="Mobile"
                  />
                </Form.Item>
              </Col> */}
            </Row>

            <div className="flex justify-end">
              <div className="flex gap-2">
                <Button type="primary" htmlType="submit">
                  Update
                </Button>

                <Button
                  className="auto-danger-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </Spin>
    </>
  );
};

export default EditSubscriptionForm;
